
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Divider, NewFeatureFormButton } from '../../app/components';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {
      /* KEYWORDS: request feature */
    }
    <h1>{`New Features in Brightlayer UI`}</h1>
    <p>{`If you'd like to see something added to Brightlayer UI, such as new patterns, components, icons, code examples, theme updates, etc., please click below and fill out the form.`}</p>
    <NewFeatureFormButton mdxType="NewFeatureFormButton" />
    <p>{`Alternatively, you may `}<a parentName="p" {...{
        "href": "/community/contactus"
      }}>{`send us an email`}</a>{`. If you'd like to add a feature yourself, please read our section on `}<a parentName="p" {...{
        "href": "/community/innersourcing"
      }}>{`innersourcing`}</a>{`. Developers can also log an issue on `}<a parentName="p" {...{
        "href": "https://github.com/brightlayer-ui"
      }}>{`GitHub`}</a>{`.`}</p>
    <Divider mdxType="Divider" />
    <h1>{`New Features in a Framework`}</h1>
    <p>{`The JavaScript libraries and their associated Material Design libraries are part of the open source community. If you want to see new features added, you can submit your requests directly to those projects using the links below (or better yet, fork the repository and contribute!):`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/angular/angular/issues"
        }}>{`Angular`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/angular/material2/issues"
            }}>{`Angular Material`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/facebook/react/issues"
        }}>{`React`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/mui-org/material-ui/issues"
            }}>{`Material-UI`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/apache/cordova/issues"
        }}>{`Apache Cordova`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ionic-team/ionic/issues"
        }}>{`Ionic`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/facebook/react-native/issues"
        }}>{`React Native`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;